<template>
  <div class="login-page">
    <img src="@/assets/taxscanai-logo.png" alt="Taxscan Logo" class="logo" />

    <h2 class="login-title">Welcome Back!</h2>

    <div class="input-group">
      <label for="username"><strong>Username:</strong></label>
      <div class="input-with-icon">
        <i class="fas fa-user icon"></i>
        <input
          type="text"
          id="username"
          v-model="loginUsername"
          placeholder="Enter your username"
          required
        />
      </div>
    </div>

    <div class="input-group">
      <label for="password"><strong>Password:</strong></label>
      <div class="input-with-icon">
        <i class="fas fa-lock icon"></i>
        <input
          type="password"
          id="password"
          v-model="loginPassword"
          placeholder="Enter your password"
          required
        />
      </div>
    </div>


    <div v-if="loginError" class="error-message">
      {{ loginError }}
    </div>

    <button @click="login" class="login-button">Login</button>
    <footer class="footer">
      <p>© {{ new Date().getFullYear() }} Taxscan Edutech Private Limited. All rights reserved.</p>
    </footer>
</div>

</template>

<script>
import axios from 'axios';

export default {
  name: 'LoginPage',
  data() {
    return {
      loginUsername: '',
      loginPassword: '',
      loginError: '',
    };
  },
  methods: {
    async login() {
      try {
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/api/local-login`, {
          username: this.loginUsername,
          password: this.loginPassword,
        });

        console.log('WP check successful');

        if (response.data.token) {
          localStorage.setItem('auth_token', response.data.token);
        } else {
          console.error('No token returned in response:', response.data);
        }

        if (response.data.credit_balance !== undefined) {
          localStorage.setItem('credit_balance', response.data.credit_balance);
        } else {
          console.error('No credit balance returned in response:', response.data);
        }

        this.$router.push('/ask-ai');
      } catch (error) {
        console.error('Login error:', error.response?.data || error.message);
        this.loginError = error.response?.data?.error || 'Login failed.';
      }
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css');


.login-page {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f9f9f9;
  justify-content: flex-start; /* Previously 'center' */
  padding-top: 0px; /* Added padding-top for spacing from top */
  font-family: 'Poppins', sans-serif;
}

.input-group {
  margin-bottom: 20px;
  width: 100%;
  max-width: 400px;
  text-align: left;
}

.input-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #444;
}

.input-group input {
  width: 100%;
  padding: 12px 12px 12px 36px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  margin-bottom: 5px;
}

.error-message {
  color: red;
  margin-bottom: 15px;
}

.login-button {
  width: 100%;
  max-width: 400px;
  padding: 14px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  background-color: #007bff;
  color: white;
  transition: 0.3s;
  margin-top: 10px;
}
.login-button:hover {
  background-color: #0056b3;
}

.input-with-icon {
  position: relative;
}

.input-with-icon .icon {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  color: #aaa;
}

.input-with-icon input {
  padding-left: 40px; /* space for the icon */
  width: 100%;
  padding: 10px 15px 10px 40px; /* Adjust padding */
  font-size: 1rem;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-sizing: border-box;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.input-with-icon input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 4px rgba(0, 123, 255, 0.3);
}

.footer {
  margin-top: 40px;
  text-align: center;
  font-size: 14px;
  color: #888;
}

.logo {
  width: 100%;
  max-width: 300px;
  height: auto;
  margin-bottom: 10px;
}

.login-title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 30px;
}

@media (max-width: 768px) {
  .login-page {
    padding: 20px;
  }

  .input-group,
  .login-button {
    width: 100%;
    padding: 10px;
  }

  .logo {
    max-width: 200px;
  }

  .footer {
    font-size: 11px; /* or any size you prefer for mobile devices */
  }
}


</style>